import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import CandidatesFilter from '@/evaluations/entities/candidates-filter'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import Candidate from '@/evaluations/entities/candidate'
import RatingListCandidate from '@/evaluations/entities/rating-list-candidate'

class CandidatesService {
  public async findOneAsync(id: string) {
    const res = await axios.get<Candidate>(`candidates?id=${id}`)
    return Responses.obj(res)
  }

  public async findAllAsync(request: CandidatesFilter) {
    const res = await axios.post<Candidate[]>(`candidates/find`, request)
    return Responses.list(res)
  }

  public async findAllPagedAsync(request: CandidatesFilter) {
    const res = await axios.post<PaginationResponse<Candidate>>(
      `candidates/find/paged`,
      request
    )
    return Responses.pagedList(res)
  }

  public async findRatingListCandidatesAsync(eId: string, jId: string) {
    const res = await axios.get<RatingListCandidate[]>(
      `candidates/find/ratinglist?eId=${eId}&jId=${jId}`
    )
    return Responses.list(res)
  }

  public async hasRatings(id: string) {
    const res = await axios.get<boolean>(`candidates/hasRatings?id=${id}`)
    return Responses.obj(res)
  }

  public async createAsync(entity: Candidate) {
    const res = await axios.post<Candidate>(`candidates`, entity)
    return Responses.obj(res)
  }
  public async updateAsync(entity: Candidate) {
    const res = await axios.put<Candidate>(`candidates`, entity)
    return Responses.obj(res)
  }

  public async deleteAsync(id: string) {
    await axios.post(`candidates/delete?id=${id}`)
  }
}

export default new CandidatesService()
